// Co-located translations for insights
// Registered dynamically when component loads
const insightsTranslations = {
  "en": {
    "insights.title": "Investment Analysis & Insights",
    "insights.subtitle": "Understand your returns, risks, and cash position",
    "target.title": "Investment Performance",
    "target.subtitle": "Are you building wealth? Compare your equity growth to stock market alternatives.",
    "target.propertyInvestment": "Property Investment (Total Equity)",
    "target.endOfYear": "End of Year {year}",
    "target.yoy": "Year-over-year",
    "target.chartExplanation": "What This Shows",
    "target.blueLine": "Blue line (Property Investment)",
    "target.blueLineDesc": "Your total equity = Initial investment + Cumulative net income",
    "target.blueLineNote": "This is AFTER all expenses: revenue - costs - depreciation - interest - taxes",
    "target.dashedLines": "Dashed lines",
    "target.dashedLinesDesc": "What your initial €{amount}k would grow to at 3%, 5%, or 8% annual returns",
    "target.noRevenueWarning": "No revenue set! Set your expected annual revenue above to see projections.",
    "target.returnsBox": "Estimated Returns at Horizon",
    "target.returnsDesc": "Cumulative growth on your initial €{amount}k investment",
    "target.indexFund5": "5% Index Fund",
    "target.indexFund8": "8% Index Fund",
    "target.propertyInvestmentLabel": "Property Investment",
    "target.nav": "Economic Equity (NAV)",
    "target.navLabel": "Economic Equity (NAV)",
    "target.orangeLine": "Orange line (Economic Equity)",
    "target.orangeLineDesc": "Your true net worth = property at market value + cash + reserves \u2212 loan",
    "target.yield3": "3% Yield",
    "target.yield5": "5% Yield",
    "target.yield8": "8% Yield",
    "target.axisYear": "Year",
    "target.axisEquity": "Equity Value (\u20AC)",
    "target.vsInitial": "vs. initial",
    "target.equityDesc": "Book value: initial equity + cumulative net income. Property at cost minus depreciation.",
    "target.navDesc": "Real-world net worth: property at market value + cash + reserves \u2212 loan.",
    "target.beat8Title": "Beat 8% Stock Returns",
    "target.beat8Desc": "Revenue needed to match typical stock market returns (8% annually). Below this, you'd be better off investing in index funds.",
    "liquidity.title": "Cash & Liquidity",
    "liquidity.subtitle": "Can you actually operate the business? Track your cash position and safety buffer.",
    "liquidity.totalLiquidAssets": "Total Liquid Assets",
    "liquidity.operatingCash": "Operating Cash",
    "liquidity.reserveFund": "Reserve Fund",
    "liquidity.dangerZone": "Danger Zone",
    "liquidity.monthBuffer": "3-Month Buffer",
    "liquidity.runway": "Runway",
    "liquidity.months": "months",
    "liquidity.chartExplanation": "What This Shows",
    "liquidity.greenLine": "Green line (Total Liquid)",
    "liquidity.greenLineDesc": "Operating cash + reserve fund = money you can actually access",
    "liquidity.blueLineDesc": "Day-to-day bank account balance",
    "liquidity.orangeLine": "Orange line (Reserves)",
    "liquidity.orangeLineDesc": "Emergency fund for unexpected repairs",
    "liquidity.redLine": "Red line (€0)",
    "liquidity.redLineDesc": "Below this = you're out of money = business fails",
    "liquidity.yellowLine": "Yellow line (3-Month Buffer)",
    "liquidity.yellowLineDesc": "Recommended minimum cash cushion",
    "liquidity.crisis": "LIQUIDITY CRISIS",
    "liquidity.crisisDesc": "Operating cash is negative! At {revenue}/year revenue, you cannot pay your bills. Need minimum {survival}/year to survive.",
    "liquidity.thinCushion": "Thin cushion",
    "liquidity.thinCushionDesc": "You have {liquid} in liquid assets, but recommended buffer is {buffer} (3 months fixed costs). One bad season could put you in danger.",
    "liquidity.healthy": "Healthy liquidity",
    "liquidity.healthyDesc": "You have {liquid} in liquid assets, well above the {buffer} recommended buffer. Good financial cushion!",
    "liquidity.survivalThreshold": "Survival Threshold",
    "liquidity.survivalDesc": "Minimum revenue to avoid running out of cash. Below this, you'll need continuous cash injections.",
    "liquidity.accountingBreakEven": "Accounting Break-Even",
    "liquidity.accountingDesc": "Revenue needed to show profit on paper (Net Income > 0). Important for banks and investors.",
    "funding.title": "Funding Gap Analysis",
    "funding.intro": "Your current revenue ({revenue}/year) cannot sustain operations.",
    "funding.annualDeficit": "Annual Cash Deficit (Avg)",
    "funding.totalDeficit": "{years}-Year Total Deficit",
    "funding.yearlyDeficits": "Additional Funding Required by Year",
    "funding.year": "Year",
    "funding.annualInjection": "Annual Injection Needed",
    "funding.cumulative": "Cumulative Total",
    "funding.investmentOutcome": "Investment Outcome",
    "funding.outcomeWarning": "Even with continuous funding injections of {amount}:",
    "funding.irrHorizon": "{years}-Year IRR",
    "funding.irrApproxNeg100": "Approximately -100% (total loss)",
    "funding.totalRisk": "Total Capital at Risk",
    "funding.initial": "Initial",
    "funding.additional": "additional",
    "funding.endState": "End State",
    "funding.endStateText": "Deeply negative equity, investment unsustainable",
    "funding.recommendation": "Recommendation",
    "funding.recommendationText": "Do not proceed at this revenue level. Investment is not viable.",
    "funding.revenueTarget": "Revenue Target",
    "funding.survivalTarget": "Survival Threshold",
    "funding.stockReturns": "Stock Market Returns (8% IRR)",
    "funding.perMonth": "/month",
    "funding.perYear": "/year",
    "funding.currentRent": "Current Monthly Rent",
    "funding.rentShortfall": "Shortfall: {amount}/month below survival threshold",
    "risk.title": "Risk Assessment",
    "risk.subtitle": "Understand your downside exposure and business resilience",
    "risk.marginOfSafety": "Margin of Safety",
    "risk.currentRevenue": "Current Revenue",
    "risk.survivalBreakEven": "Survival Break-Even",
    "risk.safetyMargin": "Safety Margin",
    "risk.negative": "Negative",
    "risk.low": "Low",
    "risk.moderate": "Moderate",
    "risk.strong": "Strong",
    "risk.marginExplanation": "Revenue can drop {percent}% before the business runs out of cash.",
    "risk.marginNegative": "Revenue is below survival threshold. Business cannot sustain operations.",
    "risk.downsideScenarios": "Downside Scenarios",
    "risk.drop20": "Revenue drops 20% for Years 1-2",
    "risk.drop50": "Revenue drops 50% for Years 1-2",
    "risk.majorRepair": "Major Unplanned Repair (Sonderumlage) in Year 3 ({amount})",
    "risk.year3Equity": "Year 3 Equity",
    "risk.vsBaseCase": "vs. Base Case",
    "risk.additionalFunding": "Additional Funding Needed",
    "risk.equityImpact": "Equity Impact",
    "risk.canContinue": "Can Continue?",
    "risk.yes": "Yes",
    "risk.noNeedsInjection": "No - needs injection",
    "risk.survivable": "Painful but survivable",
    "risk.needsBailout": "Business fails - requires bailout",
    "risk.severeDamage": "Severe damage",
    "risk.bankrupt": "Business bankrupt",
    "risk.wipesReturns": "Wipes out years of returns",
    "risk.repairExamples": "Examples: Roof damage, burst pipes, heating system failure, mold remediation, structural cracks",
    "risk.leverageRisk": "Leverage Risk",
    "risk.businessLeverage": "Business Leverage",
    "risk.debtToEquity": "Debt-to-Equity",
    "risk.interestCoverage": "Interest Coverage",
    "risk.veryHigh": "Very High",
    "risk.high": "High",
    "risk.conservative": "Conservative",
    "risk.perYear": "/year",
    "risk.leverageVeryHigh": "Very high leverage amplifies both gains and losses. Small income drops can quickly make the investment unprofitable.",
    "risk.leverageHigh": "High leverage increases risk. Ensure rental income is stable before taking on this much debt.",
    "risk.leverageModerate": "Moderate leverage provides financial flexibility while still boosting returns.",
    "risk.interestCoverageRatio": "Interest Coverage Ratio ({ratio}x)",
    "risk.icrDanger": "Danger zone. EBITDA barely covers interest.",
    "risk.icrMarginal": "Marginal. Little buffer if income drops.",
    "risk.icrAdequate": "Adequate coverage.",
    "risk.icrStrong": "Strong coverage. Low risk of default.",
    "risk.dynamicLTV": "LTV Over Time",
    "risk.navGrowth": "NAV Growth (CAGR)",
    "sensitivity.title": "Advanced Sensitivity Analysis",
    "sensitivity.subtitle": "Explore how different parameters affect your returns across 14 dimensions",
    "tornado.title": "Which Variables Matter Most?",
    "tornado.subtitle": "Ranked by total IRR impact when you change each variable.",
    "tornado.longerBars": "Longer bars = bigger impact on your returns",
    "tornado.lowering": "Lowering the variable",
    "tornado.raising": "Raising the variable",
    "tornado.noData": "No sensitivity data available.",
    "tornado.keyTakeaways": "Key Takeaways",
    "tornado.biggestLever": "Biggest Lever",
    "tornado.irrSwing": "IRR swing",
    "tornado.top3Variables": "Top 3 Variables",
    "tornado.ofTotalImpact": "of total impact",
    "tornado.smallestLever": "Smallest Lever",
    "tornado.whereToFocus": "Where to Focus",
    "tornado.focusText": "Spend your time on {var1} and {var2}. These have the biggest impact on your returns.",
    "tornado.dontWaste": "Don't waste time optimizing {var} - it barely moves the needle.",
    "improvement.title": "Improvement Opportunities",
    "improvement.currentIRR": "Current IRR",
    "improvement.seeChanges": "See what changes could improve your returns",
    "improvement.singleChanges": "Single Variable Changes",
    "improvement.singleDesc": "One change at a time — every lever shown, not just the big ones",
    "improvement.if": "if",
    "improvement.irr": "IRR",
    "improvement.noImprovement": "No improvement available",
    "improvement.combinations": "Powerful Combinations",
    "improvement.combosDesc": "MECE categories — each combination targets a different strategic area",
    "improvement.irrBecomes": "IRR becomes",
    "improvement.annualRent": "Annual Rent",
    "improvement.vacancyRate": "Vacancy Rate",
    "improvement.propertyPrice": "Property Price",
    "improvement.renovationBudget": "Renovation Budget",
    "improvement.equityCapital": "Equity Capital",
    "improvement.interestRate": "Interest Rate",
    "improvement.managementFee": "Management Fee",
    "improvement.grundsteuer": "Grundsteuer",
    "improvement.insurance": "Insurance",
    "improvement.emergencyReserve": "Emergency Reserve",
    "improvement.comboRevenue": "Revenue Optimization",
    "improvement.comboRevenueDesc": "Maximize rental income potential",
    "improvement.comboPurchase": "Purchase Negotiation",
    "improvement.comboPurchaseDesc": "Reduce upfront acquisition costs",
    "improvement.comboFinancing": "Financing Structure",
    "improvement.comboFinancingDesc": "Optimize capital structure",
    "improvement.comboOperating": "Operating Efficiency",
    "improvement.comboOperatingDesc": "Cut recurring operating costs",
    "improvement.comboMixed": "Mixed Strategy",
    "improvement.comboMixedDesc": "Revenue increase + financing optimization",
    "waterfall.title": "Year 1 Cash Flow Waterfall",
    "waterfall.subtitle": "Follow the money from revenue to free cash flow — see where every euro goes.",
    "waterfall.revenue": "Revenue",
    "waterfall.variableCosts": "Variable Costs",
    "waterfall.grossProfit": "Gross Profit",
    "waterfall.fixedCosts": "Fixed Costs",
    "waterfall.depreciation": "Depreciation",
    "waterfall.interest": "Interest",
    "waterfall.tax": "Tax",
    "waterfall.netIncome": "Net Income",
    "waterfall.addBackDepr": "+ Depreciation",
    "waterfall.loanPrincipal": "Loan Principal",
    "waterfall.freeCashFlow": "Free Cash Flow",
    "waterfall.inflow": "Inflow",
    "waterfall.outflow": "Outflow",
    "waterfall.subtotal": "Subtotal",
    "waterfall.nonCash": "Non-Cash",
    "waterfall.keyInsight": "Key Insight",
    "waterfall.keyInsightText": "Depreciation is a non-cash expense that reduces taxes but doesn't affect your bank account. That's why we add it back to calculate actual cash flow.",
    "liquidity.perYear": "/year",
    "liquidity.perMonth": "/month",
    "liquidity.endOfYear": "End of Year {year}",
    "yield.title": "Yield Metrics",
    "yield.subtitle": "Standard real estate yield metrics over time",
    "yield.brutto": "Gross Rental Yield (Bruttomietrendite)",
    "yield.netto": "Net Rental Yield (Nettomietrendite)",
    "yield.coc": "Cash-on-Cash Return",
    "yield.eqMult": "Equity Multiple (NAV)",
    "yield.bruttoDesc": "Gross rent / purchase price. Quick comparability metric.",
    "yield.nettoDesc": "Net rent (after operating costs) / purchase price.",
    "yield.cocDesc": "Free cash flow / equity invested. What you actually pocket.",
    "yield.eqMultDesc": "NAV / initial equity. Above 1.0x = you've grown your money.",
    "yield.year1": "Year 1",
    "yield.perYear": "/year",
    "decomp.title": "Return Decomposition",
    "decomp.subtitle": "Where do your returns come from? Income vs capital appreciation.",
    "decomp.incomeReturn": "Income Return",
    "decomp.capitalReturn": "Capital Appreciation",
    "decomp.totalReturn": "Total Return",
    "decomp.incomeShare": "Income Share",
    "decomp.capitalShare": "Appreciation Share",
    "decomp.taxNote": "Income is taxed annually. Unrealized gains are only taxed on sale (within Spekulationsfrist).",
    "decomp.endOfHorizon": "End of Projection"
  },
  "de": {
    "insights.title": "Investitionsanalyse & Erkenntnisse",
    "insights.subtitle": "Verstehen Sie Ihre Renditen, Risiken und Liquidität",
    "target.title": "Investitionsperformance",
    "target.subtitle": "Bauen Sie Vermögen auf? Vergleichen Sie Ihr Eigenkapitalwachstum mit Börsenalternativen.",
    "target.propertyInvestment": "Immobilien-Investment (Gesamtes Eigenkapital)",
    "target.endOfYear": "Ende Jahr {year}",
    "target.yoy": "Gegenüber Vorjahr",
    "target.chartExplanation": "Was zeigt dies",
    "target.blueLine": "Blaue Linie (Immobilien-Investment)",
    "target.blueLineDesc": "Ihr Gesamteigenkapital = Anfangsinvestition + Kumulierter Jahresüberschuss",
    "target.blueLineNote": "Dies ist NACH allen Ausgaben: Umsatz - Kosten - Abschreibung - Zinsen - Steuern",
    "target.dashedLines": "Gestrichelte Linien",
    "target.dashedLinesDesc": "Was Ihre anfänglichen €{amount}k bei 3%, 5% oder 8% jährlicher Rendite ergäben",
    "target.noRevenueWarning": "Kein Umsatz festgelegt! Legen Sie oben Ihren erwarteten Jahresumsatz fest.",
    "target.returnsBox": "Geschätzte Rendite am Horizont",
    "target.returnsDesc": "Kumulatives Wachstum auf Ihre anfänglichen €{amount}k Investition",
    "target.indexFund5": "5% Indexfonds",
    "target.indexFund8": "8% Indexfonds",
    "target.propertyInvestmentLabel": "Immobilien-Investment",
    "target.nav": "Wirtschaftliches Eigenkapital (NAV)",
    "target.navLabel": "Wirtschaftl. EK (NAV)",
    "target.orangeLine": "Orange Linie (Wirtschaftl. EK)",
    "target.orangeLineDesc": "Ihr Nettowert = Marktwert + Kasse + R\u00fccklagen \u2212 Darlehen",
    "target.yield3": "3% Rendite",
    "target.yield5": "5% Rendite",
    "target.yield8": "8% Rendite",
    "target.axisYear": "Jahr",
    "target.axisEquity": "Eigenkapitalwert (\u20AC)",
    "target.vsInitial": "vs. Anfang",
    "target.equityDesc": "Buchwert: Anfangseigenkapital + kumulierter Jahresüberschuss. Immobilie zu Anschaffungskosten abzgl. AfA.",
    "target.navDesc": "Tatsächlicher Nettowert: Immobilie zum Marktwert + Kasse + Rücklagen \u2212 Darlehen.",
    "target.beat8Title": "8% Börsenrendite übertreffen",
    "target.beat8Desc": "Umsatz erforderlich um typische Börsenrenditen (8% jährlich) zu erreichen. Darunter wären Indexfonds besser.",
    "liquidity.title": "Kasse & Liquidität",
    "liquidity.subtitle": "Können Sie das Geschäft tatsächlich betreiben? Verfolgen Sie Ihre Kassenposition und Sicherheitspuffer.",
    "liquidity.totalLiquidAssets": "Gesamte liquide Mittel",
    "liquidity.operatingCash": "Betriebskasse",
    "liquidity.reserveFund": "Rücklagenfonds",
    "liquidity.dangerZone": "Gefahrenzone",
    "liquidity.monthBuffer": "3-Monats-Puffer",
    "liquidity.runway": "Reichweite",
    "liquidity.months": "Monate",
    "liquidity.chartExplanation": "Was zeigt dies",
    "liquidity.greenLine": "Grüne Linie (Gesamt liquide)",
    "liquidity.greenLineDesc": "Betriebskasse + Rücklagenfonds = Geld auf das Sie zugreifen können",
    "liquidity.blueLineDesc": "Täglicher Kontostand",
    "liquidity.orangeLine": "Orange Linie (Rücklagen)",
    "liquidity.orangeLineDesc": "Notfallfonds für unerwartete Reparaturen",
    "liquidity.redLine": "Rote Linie (€0)",
    "liquidity.redLineDesc": "Darunter = kein Geld mehr = Geschäft scheitert",
    "liquidity.yellowLine": "Gelbe Linie (3-Monats-Puffer)",
    "liquidity.yellowLineDesc": "Empfohlenes minimales Kassenpolster",
    "liquidity.crisis": "LIQUIDITÄTSKRISE",
    "liquidity.crisisDesc": "Betriebskasse ist negativ! Bei {revenue}/Jahr Umsatz können Sie Ihre Rechnungen nicht bezahlen. Minimum {survival}/Jahr benötigt.",
    "liquidity.thinCushion": "Dünnes Polster",
    "liquidity.thinCushionDesc": "Sie haben {liquid} an liquiden Mitteln, aber empfohlener Puffer ist {buffer} (3 Monate Fixkosten). Eine schlechte Saison könnte Sie gefährden.",
    "liquidity.healthy": "Gesunde Liquidität",
    "liquidity.healthyDesc": "Sie haben {liquid} an liquiden Mitteln, deutlich über dem empfohlenen Puffer von {buffer}. Gutes Finanzpolster!",
    "liquidity.survivalThreshold": "Überlebensschwelle",
    "liquidity.survivalDesc": "Mindestumsatz um nicht ohne Geld dazustehen. Darunter benötigen Sie kontinuierliche Kapitalspritzen.",
    "liquidity.accountingBreakEven": "Buchhalterische Gewinnschwelle",
    "liquidity.accountingDesc": "Umsatz für Gewinn auf dem Papier (Jahresüberschuss > 0). Wichtig für Banken und Investoren.",
    "funding.title": "Finanzierungslücken-Analyse",
    "funding.intro": "Ihr aktueller Umsatz ({revenue}/Jahr) kann den Betrieb nicht aufrechterhalten.",
    "funding.annualDeficit": "Jährliches Kassendefizit (Durchschn.)",
    "funding.totalDeficit": "{years}-Jahres-Gesamtdefizit",
    "funding.yearlyDeficits": "Zusätzliche Finanzierung nach Jahr erforderlich",
    "funding.year": "Jahr",
    "funding.annualInjection": "Jährliche Einlage benötigt",
    "funding.cumulative": "Kumuliert gesamt",
    "funding.investmentOutcome": "Investitionsergebnis",
    "funding.outcomeWarning": "Selbst bei kontinuierlichen Kapitalspritzen von {amount}:",
    "funding.irrHorizon": "{years}-Jahres-IRR",
    "funding.irrApproxNeg100": "Ca. -100% (Totalverlust)",
    "funding.totalRisk": "Gesamtkapital im Risiko",
    "funding.initial": "Anfänglich",
    "funding.additional": "zusätzlich",
    "funding.endState": "Endzustand",
    "funding.endStateText": "Tief negatives Eigenkapital, Investment nicht tragfähig",
    "funding.recommendation": "Empfehlung",
    "funding.recommendationText": "Bei diesem Umsatzniveau nicht fortfahren. Investment nicht tragfähig.",
    "funding.revenueTarget": "Umsatzziel",
    "funding.survivalTarget": "Überlebensschwelle",
    "funding.stockReturns": "Börsenrendite (8% IRR)",
    "funding.perMonth": "/Monat",
    "funding.perYear": "/Jahr",
    "funding.currentRent": "Aktuelle Monatsmiete",
    "funding.rentShortfall": "Fehlbetrag: {amount}/Monat unter der Überlebensschwelle",
    "risk.title": "Risikobewertung",
    "risk.subtitle": "Verstehen Sie Ihr Abwärtsrisiko und die Geschäftsresilienz",
    "risk.marginOfSafety": "Sicherheitsmarge",
    "risk.currentRevenue": "Aktueller Umsatz",
    "risk.survivalBreakEven": "Überlebens-Break-Even",
    "risk.safetyMargin": "Sicherheitsmarge",
    "risk.negative": "Negativ",
    "risk.low": "Niedrig",
    "risk.moderate": "Moderat",
    "risk.strong": "Stark",
    "risk.marginExplanation": "Der Umsatz kann um {percent}% fallen, bevor dem Geschäft das Geld ausgeht.",
    "risk.marginNegative": "Umsatz liegt unter der Überlebensschwelle. Geschäft kann Betrieb nicht aufrechterhalten.",
    "risk.downsideScenarios": "Abwärtsszenarien",
    "risk.drop20": "Umsatz sinkt um 20% in Jahr 1-2",
    "risk.drop50": "Umsatz sinkt um 50% in Jahr 1-2",
    "risk.majorRepair": "Ungeplante Großreparatur (Sonderumlage) in Jahr 3 ({amount})",
    "risk.year3Equity": "Eigenkapital Jahr 3",
    "risk.vsBaseCase": "vs. Basisfall",
    "risk.additionalFunding": "Zusätzliche Finanzierung benötigt",
    "risk.equityImpact": "Eigenkapital-Auswirkung",
    "risk.canContinue": "Fortfahren möglich?",
    "risk.yes": "Ja",
    "risk.noNeedsInjection": "Nein - braucht Kapitalspritze",
    "risk.survivable": "Schmerzhaft aber überlebbar",
    "risk.needsBailout": "Geschäft scheitert - braucht Rettung",
    "risk.severeDamage": "Schwerer Schaden",
    "risk.bankrupt": "Geschäft insolvent",
    "risk.wipesReturns": "Vernichtet Jahre an Rendite",
    "risk.repairExamples": "Beispiele: Dachschaden, Rohrbruch, Heizungsausfall, Schimmelbeseitigung, Risse im Mauerwerk",
    "risk.leverageRisk": "Verschuldungsrisiko",
    "risk.businessLeverage": "Geschäftsverschuldung",
    "risk.debtToEquity": "Fremd-/Eigenkapitalquote",
    "risk.interestCoverage": "Zinsdeckungsgrad",
    "risk.veryHigh": "Sehr hoch",
    "risk.high": "Hoch",
    "risk.conservative": "Konservativ",
    "risk.perYear": "/Jahr",
    "risk.leverageVeryHigh": "Sehr hoher Verschuldungsgrad verstärkt Gewinne und Verluste. Kleine Einkommensrückgänge können das Investment schnell unrentabel machen.",
    "risk.leverageHigh": "Hoher Verschuldungsgrad erhöht das Risiko. Stellen Sie stabile Mieteinnahmen sicher, bevor Sie so viel Fremdkapital aufnehmen.",
    "risk.leverageModerate": "Moderater Verschuldungsgrad bietet finanzielle Flexibilität bei gleichzeitiger Renditesteigerung.",
    "risk.interestCoverageRatio": "Zinsdeckungsgrad ({ratio}x)",
    "risk.icrDanger": "Gefahrenzone. EBITDA deckt kaum die Zinsen.",
    "risk.icrMarginal": "Knapp. Wenig Puffer bei Einkommensrückgang.",
    "risk.icrAdequate": "Ausreichende Deckung.",
    "risk.icrStrong": "Starke Deckung. Geringes Ausfallrisiko.",
    "risk.dynamicLTV": "LTV-Entwicklung",
    "risk.navGrowth": "NAV-Wachstum (CAGR)",
    "sensitivity.title": "Erweiterte Sensitivitätsanalyse",
    "sensitivity.subtitle": "Erkunden Sie, wie verschiedene Parameter Ihre Renditen über 14 Dimensionen beeinflussen",
    "tornado.title": "Welche Variablen sind am wichtigsten?",
    "tornado.subtitle": "Rangfolge nach Gesamt-IRR-Auswirkung bei Änderung jeder Variable.",
    "tornado.longerBars": "Längere Balken = größerer Einfluss auf Ihre Renditen",
    "tornado.lowering": "Variable senken",
    "tornado.raising": "Variable erhöhen",
    "tornado.noData": "Keine Sensitivitätsdaten verfügbar.",
    "tornado.keyTakeaways": "Wichtigste Erkenntnisse",
    "tornado.biggestLever": "Größter Hebel",
    "tornado.irrSwing": "IRR-Schwankung",
    "tornado.top3Variables": "Top 3 Variablen",
    "tornado.ofTotalImpact": "der Gesamtauswirkung",
    "tornado.smallestLever": "Kleinster Hebel",
    "tornado.whereToFocus": "Worauf konzentrieren",
    "tornado.focusText": "Verbringen Sie Ihre Zeit mit {var1} und {var2}. Diese haben den größten Einfluss auf Ihre Renditen.",
    "tornado.dontWaste": "Verschwenden Sie keine Zeit mit der Optimierung von {var} - es bewegt kaum etwas.",
    "improvement.title": "Verbesserungsmöglichkeiten",
    "improvement.currentIRR": "Aktueller IRR",
    "improvement.seeChanges": "Sehen Sie, welche Änderungen Ihre Renditen verbessern könnten",
    "improvement.singleChanges": "Einzelne Variablenänderungen",
    "improvement.singleDesc": "Eine Änderung auf einmal — jeder Hebel gezeigt, nicht nur die großen",
    "improvement.if": "wenn",
    "improvement.irr": "IRR",
    "improvement.noImprovement": "Keine Verbesserung möglich",
    "improvement.combinations": "Starke Kombinationen",
    "improvement.combosDesc": "MECE-Kategorien — jede Kombination zielt auf einen anderen strategischen Bereich",
    "improvement.irrBecomes": "IRR wird",
    "improvement.annualRent": "Jahresmiete",
    "improvement.vacancyRate": "Leerstandsquote",
    "improvement.propertyPrice": "Kaufpreis",
    "improvement.renovationBudget": "Renovierungsbudget",
    "improvement.equityCapital": "Eigenkapital",
    "improvement.interestRate": "Zinssatz",
    "improvement.managementFee": "Verwaltungsgebühr",
    "improvement.grundsteuer": "Grundsteuer",
    "improvement.insurance": "Versicherung",
    "improvement.emergencyReserve": "Notfallreserve",
    "improvement.comboRevenue": "Einnahmenoptimierung",
    "improvement.comboRevenueDesc": "Mieteinnahmen maximieren",
    "improvement.comboPurchase": "Kaufverhandlung",
    "improvement.comboPurchaseDesc": "Anschaffungskosten reduzieren",
    "improvement.comboFinancing": "Finanzierungsstruktur",
    "improvement.comboFinancingDesc": "Kapitalstruktur optimieren",
    "improvement.comboOperating": "Betriebseffizienz",
    "improvement.comboOperatingDesc": "Laufende Betriebskosten senken",
    "improvement.comboMixed": "Gemischte Strategie",
    "improvement.comboMixedDesc": "Mieterhöhung + Finanzierungsoptimierung",
    "waterfall.title": "Jahr 1 Cashflow-Wasserfall",
    "waterfall.subtitle": "Folgen Sie dem Geld vom Umsatz zum freien Cashflow — sehen Sie, wohin jeder Euro geht.",
    "waterfall.revenue": "Umsatz",
    "waterfall.variableCosts": "Variable Kosten",
    "waterfall.grossProfit": "Bruttogewinn",
    "waterfall.fixedCosts": "Fixkosten",
    "waterfall.depreciation": "Abschreibung",
    "waterfall.interest": "Zinsen",
    "waterfall.tax": "Steuern",
    "waterfall.netIncome": "Jahresüberschuss",
    "waterfall.addBackDepr": "+ Abschreibung",
    "waterfall.loanPrincipal": "Tilgung",
    "waterfall.freeCashFlow": "Freier Cashflow",
    "waterfall.inflow": "Zufluss",
    "waterfall.outflow": "Abfluss",
    "waterfall.subtotal": "Zwischensumme",
    "waterfall.nonCash": "Nicht-Cash",
    "waterfall.keyInsight": "Wichtiger Hinweis",
    "waterfall.keyInsightText": "Abschreibung ist ein nicht zahlungswirksamer Aufwand, der Steuern reduziert, aber Ihr Bankkonto nicht beeinflusst. Deshalb addieren wir sie zurück, um den tatsächlichen Cashflow zu berechnen.",
    "liquidity.perYear": "/Jahr",
    "liquidity.perMonth": "/Monat",
    "liquidity.endOfYear": "Ende Jahr {year}",
    "yield.title": "Renditekennzahlen",
    "yield.subtitle": "Immobilien-Renditekennzahlen im Zeitverlauf",
    "yield.brutto": "Bruttomietrendite",
    "yield.netto": "Nettomietrendite",
    "yield.coc": "Cash-on-Cash-Rendite",
    "yield.eqMult": "Eigenkapitalmultiplikator (NAV)",
    "yield.bruttoDesc": "Bruttomiete / Kaufpreis. Schnelle Vergleichskennzahl.",
    "yield.nettoDesc": "Nettomiete (nach Betriebskosten) / Kaufpreis.",
    "yield.cocDesc": "Freier Cashflow / eingesetztes Eigenkapital. Was Sie tatsächlich erhalten.",
    "yield.eqMultDesc": "NAV / Anfangseigenkapital. Über 1,0x = Ihr Geld ist gewachsen.",
    "yield.year1": "Jahr 1",
    "yield.perYear": "/Jahr",
    "decomp.title": "Renditezerlegung",
    "decomp.subtitle": "Woher kommen Ihre Erträge? Einkommen vs. Wertsteigerung.",
    "decomp.incomeReturn": "Einkommensrendite",
    "decomp.capitalReturn": "Wertsteigerungsrendite",
    "decomp.totalReturn": "Gesamtrendite",
    "decomp.incomeShare": "Einkommensanteil",
    "decomp.capitalShare": "Wertsteigerungsanteil",
    "decomp.taxNote": "Einkommen wird jährlich besteuert. Stille Reserven werden erst bei Verkauf besteuert (innerhalb der Spekulationsfrist).",
    "decomp.endOfHorizon": "Am Prognosehorizont"
  }
};

export default insightsTranslations;
